// 共享的 Studio / Teable host 推断
// 用途:DevView iframe src 默认值、TelegramChat 气泡 a 链接拦截判断

export function pickStudioUrl() {
  const host = location.hostname
  const isDev = host === 'localhost' || host === '127.0.0.1' || host.startsWith('192.168.') || host === 'dev-arp.fengbao.com' || host === '8.219.1.89'
  return isDev ? 'https://dev-studio.fengbao.com/' : 'https://studio.fengbao.com/'
}

// 当前 dev iframe 默认加载的 Studio host(含端口),用作拦截/校验对比
export function currentStudioHost() {
  try { return new URL(pickStudioUrl()).host } catch (_) { return '' }
}

// 当前 Teable host:跟 FuncBar.logout 已有规则一致 — ARP host 里的 'arp' 替换为 'teable',兜底 dev-teable
export function currentTableHost() {
  const host = location.hostname
  if (host.includes('arp')) return host.replace(/arp/, 'teable')
  return 'dev-teable.fengbao.com'
}
